import { Text, View, StyleSheet, TouchableOpacity } from 'react-native';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { defaultScale } from '../../utils/scaling';
import Theme from '../../theme';
import moment from 'moment-timezone';

class DateTile extends Component {
  props: any;
  render() {
    const isSelectedDay = moment(this.props.date).isSame(
      moment(this.props.selectedDay.date),
      'day'
    );
    const fontWeightToUse = isSelectedDay ? Theme.Weight700 : Theme.Weight400;
    const textColorToUse = isSelectedDay ? Theme.WHITE : Theme.PRIMARY;
    const backgroundColorToUse = isSelectedDay ? Theme.PRIMARY : Theme.WHITE;
    const textStyle = {
      fontFamily: fontWeightToUse,
      color: textColorToUse,
    };

    return (
      <View style={styles.mainContainer}>
        <TouchableOpacity
          style={[styles.container, { backgroundColor: backgroundColorToUse, borderColor: Theme.PRIMARY }]}
          onPress={() => {
            this.props.workoutDateTimeSelected(this.props.date);
          }}
        >
          <View style={styles.dateContainer}>
            <Text
              style={[
                styles.slotInfoText,
                textStyle,
              ]}
            >
              {moment(this.props.date).format('dddd')}
            </Text>
            <Text
              style={[
                styles.slotInfoText,
                textStyle,
              ]}
            >
              {moment(this.props.date).format('D MMMM')}
            </Text>
          </View>
        </TouchableOpacity>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  mainContainer: {
    height: defaultScale(60),
    marginBottom: defaultScale(15),
  },
  container: {
    height: '100%',
    borderWidth: defaultScale(1),
    borderRadius: defaultScale(3),
    alignItems: 'center',
  },
  dateContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  slotInfoText: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.PRIMARY,
    paddingHorizontal: defaultScale(10),
  },
  slotUserStateText: {
    ...Theme.textStyle.bodyCopyReg,
    textAlign: 'center',
    color: Theme.PRIMARY,
  },
});

export default translate(['bookings'], { wait: true })(DateTile);
